import type { Job, RecordJobData } from "@smartsuite/automation-engine-api";
import { makeAutoObservable } from "mobx";

const INITIAL_JOB: Job = {
  jobId: "",
  automationId: "",
  actions: [],
  changeId: "",
  actionGroupsStatus: [],
};

export class JobDetailsStore {
  job = INITIAL_JOB;
  recordJobData: RecordJobData[] = [];
  loading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  setJobDetails(job: Job, recordJobData: RecordJobData[] = []): void {
    this.job = job;
    this.recordJobData = recordJobData;
  }

  updateRecordData(recordJobData: RecordJobData): void {
    const index = this.recordJobData.findIndex(
      (item) => item.recordJobId === recordJobData.recordJobId,
    );

    if (index !== -1) {
      this.recordJobData[index] = recordJobData;
    } else {
      this.recordJobData.push(recordJobData);
    }
  }

  isLoading(): boolean {
    return this.loading;
  }

  setLoading(loading: boolean): void {
    this.loading = loading;
  }
}
